var map = {
	"./doc.svg": "908b",
	"./folder.svg": "7dfe",
	"./jpeg.svg": "e349",
	"./jpg.svg": "46b9",
	"./left.svg": "fc9b",
	"./mov.svg": "b851",
	"./mp4.svg": "462d",
	"./other.svg": "48d4",
	"./pdf.svg": "f367",
	"./png.svg": "533e",
	"./ppt.svg": "8615",
	"./progress-bg.svg": "23e5",
	"./upload.svg": "f4d7",
	"./xls.svg": "3840",
	"./xlsx.svg": "9549"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e198";